import { Maybe } from 'types/FMSGraphqlTypes'
import { TCarrierHeavyLoadPreference } from '../types'

export const getHeavyLoadsLabel = (
  loadingCapability: Maybe<TCarrierHeavyLoadPreference>
): 'Yes' | 'No' => {
  const { isHeavyLoadCapable } = loadingCapability || {}
  return isHeavyLoadCapable ? 'Yes' : 'No'
}
